import type { HelpFile } from '../../types/help'
import { CampaignFormFieldsTestIds } from '../../../testids/CampaignFormFieldsTestIds'

export const campaignFormFieldsHelp: HelpFile = {
  docPage: '/docs/governance/certification-campaigns',
  texts: {
    [CampaignFormFieldsTestIds.campaignInputName]:
      'Name, der für die Kampagne in Listen und Prüfer-Benachrichtigungen angezeigt wird.',
    [CampaignFormFieldsTestIds.campaignInputDescription]:
      'Optionale Beschreibung, die Prüfern beim Öffnen der Kampagne angezeigt wird.',
    [CampaignFormFieldsTestIds.campaignInputDueDate]:
      'Stichtag, bis zu dem alle Prüfungen der Kampagne abgeschlossen sein müssen.',
    [CampaignFormFieldsTestIds.campaignComboboxOwner]:
      'Verantwortliche Identität für die Kampagne — erhält Erinnerungen und Überfälligkeitsmeldungen.',
  },
}
